import { render, staticRenderFns } from "./EmArchFixedAssetDisposalQueryView.vue?vue&type=template&id=0bc8fbb7&scoped=true&"
import script from "./EmArchFixedAssetDisposalQueryView.vue?vue&type=script&lang=js&"
export * from "./EmArchFixedAssetDisposalQueryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc8fbb7",
  null
  
)

export default component.exports